import React, { useState, useEffect } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../../config/config';
import { FiArrowRight } from 'react-icons/fi';

const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 5 },
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 }
};

const StudyGoalSection = () => {
    const [cardData, setCardData] = useState([]);

    useEffect(() => {
        const fetchCardData = async () => {
            try {
                const response = await axios.get(`${config.API_BASE_URL}/api/admin/get_cardslider`);
                setCardData(response.data.allCardslider || []);
            } catch (error) {
                console.error("Error fetching study goals:", error);
            }
        };
        fetchCardData();
    }, []);

    const getImage = (index) => {
        const images = [
            "https://cdn-icons-png.flaticon.com/512/265/265674.png",
            "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
            "https://cdn-icons-png.flaticon.com/512/2436/2436874.png",
            "https://cdn-icons-png.flaticon.com/512/1940/1940611.png"
        ];
        return images[index % images.length];
    };

    if (cardData.length === 0) return null;

    return (
        <section className="py-20 bg-white relative z-10">
            <div className="container mx-auto px-4">
                {/* Outer Border Container */}
                <div className="border-2 border-orange-200 rounded-3xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl font-bold text-gray-800">
                            Select Your <span className="text-brand-orange">Study Goal</span>
                        </h2>
                        <p className="text-gray-500 mt-2 max-w-2xl mx-auto">
                            Whether you're aiming to boost your skills, prepare for exams, or explore new knowledge areas, start your journey here.
                        </p>
                    </div>

                    {/* Carousel with low z-index buttons */}
                    <div className="relative">
                        <style>{`
                            .study-goal-carousel .react-multiple-carousel__arrow {
                                z-index: 10 !important;
                            }
                            .study-goal-carousel .react-multiple-carousel__arrow:hover {
                                background: rgba(0, 0, 0, 0.8) !important;
                            }
                        `}</style>
                        <Carousel
                            responsive={responsive}
                            infinite
                            autoPlay
                            autoPlaySpeed={4000}
                            removeArrowOnDeviceType={["tablet", "mobile"]}
                            containerClass="pb-4 study-goal-carousel"
                            itemClass="px-2"
                        >
                            {cardData.map((item, index) => (
                                <div key={index} className="h-full px-2">
                                    <div className="bg-gray-50 rounded-2xl border border-gray-200 p-6 h-full hover:shadow-xl hover:border-brand-orange transition-all duration-300">
                                        <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gray-100">
                                            <img
                                                src={getImage(index)}
                                                alt=""
                                                className="w-12 h-12 object-contain opacity-80"
                                            />
                                            <div>
                                                <h4 className="font-bold text-lg text-gray-800">{item.cardName}</h4>
                                                <p className="text-xs text-brand-orange font-semibold uppercase tracking-wider">
                                                    {item.cardCollageTitle}
                                                </p>
                                            </div>
                                        </div>

                                        <div className="space-y-2">
                                            {[item.linkname1, item.linkname2, item.linkname3]
                                                .filter(Boolean)
                                                .map((link, i) => (
                                                    <Link
                                                        key={i}
                                                        to={`/c_pages/${link}`}
                                                        className="block w-full bg-white hover:bg-orange-50 px-4 py-3 rounded-lg text-sm font-medium text-gray-700 hover:text-brand-orange transition flex items-center justify-between group"
                                                    >
                                                        <span>{link}</span>
                                                        <FiArrowRight className="opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
                                                    </Link>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Carousel>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default StudyGoalSection;
